define('sentient/aba/views/WindowView',[
    'jquery',
    'underscore',
    'backbone',
    'loglevel',
    '../app'
], function($, _, Backbone, log, app) {
    log.trace('WindowView.js');
    var WindowView = Backbone.View.extend({
        el: 'html',
        events: {},
        defaults: function() {},
        initialize: function() {
            var view = this;
            view.listenTo(view.model, 'change:windowSize', view.resize);
            view.resize(view.model, view.model.get('windowSize'), {});
            view.on('resize-check', function() {
                log.debug("resize-check: ", view.model.get('windowSize'));
                view.resize(view.model, view.model.get('windowSize'), {});
            });
        },
        render: function() {},
        resize: function(model, newSize, options) {
            var newHeight = newSize.height;
            $('.force-window-height').each(function(index, el) {
                //log.debug("force-window-height: ",el,$(el).outerHeight(true));
                newHeight = Math.max(newHeight, $(el).outerHeight(true));
            });
            if (newHeight <= newSize.height) {
                newHeight = '100%';
            }
            this.$el.css({
                width: '100%',
                height: newHeight
            });
            this.$el.find('body').css({
                width: '100%',
                height: newHeight
            });
            app.trigger('resizeComplete');
        }
    });
    return WindowView;
});
